import FileSystemList from "../views/FileSystemList"
import FileSystemDetail from "../views/FileSystemDetail"
import FileSystemCreate from "../views/FileSystemCreate"
import FileSystemSettings from "../views/FileSystemSettings"
import FileSystemLogs from "../views/FileSystemLogs"

export default [
	{
		path: "/:tenantId/file-system",
		component: FileSystemList,
		name: "FileSystemList",
		meta: { featureId: "fileSystem" },
		props: true
	},
	{
		path: "/:tenantId/file-system/detail/:id",
		component: FileSystemDetail,
		name: "FileSystemDetail",
		meta: { featureId: "fileSystem" },
		props: true
	},
	{
		path: "/:tenantId/file-system/create",
		component: FileSystemCreate,
		name: "FileSystemCreate",
		meta: { featureId: "fileSystem" },
		props: true
	},
	{
		path: "/:tenantId/file-system/settings/:id",
		component: FileSystemSettings,
		name: "FileSystemSettings",
		meta: { featureId: "fileSystem" },
		props: true
	},
	{
		path: "/:tenantId/file-system/logs/:id",
		component: FileSystemLogs,
		name: "FileSystemLogs",
		meta: { featureId: "fileSystem" },
		props: true
	}
]
